// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    AskForQuoteApiParameter,
    postAskForQuote,
} from "@store/Framework/Services/Components/AskForQuote/AskForQuoteService";
import { AskForQuoteModel } from "@store/Framework/Types/ApiModels";

export interface AskForQuoteParameter {
    sku: string;
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    phone: string;
    province: string;
    city: string;
    comments: string;
    onSuccess?: () => void;
}

type HandlerType = ApiHandlerDiscreteParameter<AskForQuoteParameter, AskForQuoteApiParameter, AskForQuoteModel>;

export const PopulateApiParameter: HandlerType = props => {
    const askForQuoteModel = {
        sku: props.parameter.sku,
        firstName: props.parameter.firstName,
        lastName: props.parameter.lastName,
        email: props.parameter.email,
        company: props.parameter.company,
        phone: props.parameter.phone,
        province: props.parameter.province,
        city: props.parameter.city,
        comments: props.parameter.comments,
    } as AskForQuoteModel;
    props.apiParameter = { askForQuoteModel };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await postAskForQuote(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const askForQuote = createHandlerChainRunner(chain, "AskForQuote");
export default askForQuote;
